import * as React from 'react';
import './Summary.css';

export interface SummaryData {
    text: string;
    value: string | number;
}

interface Props {
    data: SummaryData[];
    goBackLink: JSX.Element;
    onExportClicked: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

class SummaryDetails extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <>
                <div className="summary-navigation">
                    {this.props.goBackLink}
                    <div>
                        <button className="link-button" onClick={this.print}>
                            Print
                        </button>
                        <button className="link-button" onClick={this.props.onExportClicked}>
                            Export
                        </button>
                    </div>
                </div>
                <div className="summary-details">
                    {this.props.data.map((elem: SummaryData) => this.renderDataTile(elem.text, elem.value))}
                </div>
            </>
        );
    }

    private print = (): void => window.print();

    private renderDataTile = (header: string, value: string | number): JSX.Element => {
        return (
            <div>
                <p className="details-header">{header}</p>
                <p className="details-value">{value}</p>
            </div>
        );
    };
}

export default SummaryDetails;



// WEBPACK FOOTER //
// ./src/view/SummaryDetails.tsx